"use client";
import dayjs from "dayjs";
import constate from "constate";
import { useState } from "react";
import { toast } from "react-toastify";
import { getErrorMessage } from "../utils";
import { createCart } from "@/app/(procure)/procure/cart/services";
import { LineItemsPayload } from "@/app/(procure)/procure/imports/types";

function useImportStore() {
  const [selectedVariants, setSelectedVariants] = useState<LineItemsPayload[]>(
    [],
  );
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | undefined>(
    undefined,
  );
  const [quantity, setQuantity] = useState(0);
  function deleteVariant(variantId: string) {
    setSelectedVariants(
      selectedVariants.filter((variant) => variant.variantId !== variantId),
    );
  }
  function calculateTotalQuantity(variants: LineItemsPayload[]) {
    return variants?.reduce((total, product) => total + product.quantity, 0);
  }
  function calculateSubTotalPrice(variants: LineItemsPayload[]) {
    return variants?.reduce(
      (total, product) => total + product.price * product.quantity,
      0,
    );
  }

  async function createCartRequest() {
    setLoading(true);
    const payload = {
      metadata: {
        text: `Cart updated on ${dayjs().format("D MMMM YYYY [at] HH:mm")}`,
      },
      lineItems: selectedVariants,
    };
    const response = await createCart(payload);
    if (response.error) {
      setLoading(false);
      toast.error(getErrorMessage(response));
      return;
    }
    setLoading(false);
    toast.success("Added to cart!");
    return response;
  }

  return {
    selectedVariants,
    setSelectedVariants,
    quantity,
    setQuantity,
    calculateTotalQuantity,
    calculateSubTotalPrice,
    deleteVariant,
    createCartRequest,
    loading,
    selectedImage,
    setSelectedImage,
  };
}

export const [ImportProvider, useImportsContext] = constate(useImportStore);
